import { _, makeGtmCall, closestEl } from './../utils.js'
import Validate from '../modules/validate.js'
export default class FormValidate {
    constructor(el) {
        this.form = el
        this.pristine = new Validate(this.form)
        this.form.addEventListener('submit', this.formSubmit)
        // community store package does not like the pattern attribute, checkout will not submit without it
        this.patternElement = document.querySelector(
            '#store-checkout-billing-phone',
        )
    }

    formSubmit = (e) => {
        const valid = this.pristine.validate()
        const formSection = _('step-section', 'element').nodeFrom(this.form)

        if (!valid && formSection) {
            const pristineError = document.querySelector('.pristine-error')
            const errorSection = closestEl(formSection, pristineError)
            const stepTrigger = this.form.querySelector(
                `[data-element="step"][data-target="${errorSection.dataset.targetId}"]`,
            )

            const clickEvent = new Event('click')
            stepTrigger.dispatchEvent(clickEvent)
        }

        if (!valid) {
            if (this.patternElement) {
                this.patternElement.setAttribute('pattern', '/[0-9]/g')
            }
            e.stopImmediatePropagation()
            e.preventDefault()
        }

        if (valid) {
            if (this.patternElement) {
                this.patternElement.removeAttribute('pattern')
            }
            this.form.dataset.gtmEvent =
                this.form.dataset.gtmEvent || 'form-submit'
            this.form.dataset.gtmName =
                this.form.dataset.gtmName || this.form.action

            makeGtmCall(this.form)
        }
    }
}
